export const DEMOGRAPHIC_SURVEY_HIDE = 0;
export const DEMOGRAPHIC_SURVEY_RESTRICTED = 1;
export const DEMOGRAPHIC_SURVEY_SHOW = 2;
